import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import BackButton from "../components/global/BackButton";
import axios from "axios";
import Loading from "../components/global/Loading";
import Heading from "../components/results/Heading";
import Table from "../components/results/Table";

export default function MyResults() {
    const [ data, setData ] = useState(null);
    const location = useLocation();
    useState(() => {
        async function getData() {
            try {
                await axios({
                    method: 'post',
                    url: 'https://signupapp-backend-app-9b09cbe965e9.herokuapp.com/api/restricted/results',
                    data: { id: location.state._id }
                }).then(response => {
                    setData(response.data)
                });
            } catch(error) { console.log(error) }
        };
        getData();
    }, [] );

    return (
        <div className="page">
            <BackButton/>
            { !data ? <Loading/> : (
                <>
                <Heading results={data.length} name={location.state.name}/>
                <Table data={data}/>
                </>
            ) }
        </div>
    )
};